(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jj-gallery-filters"] && !Shopify.designMode) return;
  try {
    function initialiseJJFilters(){
 const gallery=document.getElementById('paintings');
 const form=gallery?.querySelector('.jj-filters');
 if(!form||form.dataset.ready)return;
 const cards=[...gallery.querySelectorAll('.work[data-art-price]')];
 if(!cards.length)return;
 const groups=JSON.parse(gallery.querySelector('.jj-filter-groups').textContent);
 const count=form.querySelector('.jj-filter-count');
 const empty=gallery.querySelector('.jj-filter-empty');
 const entries=cards.map(card=>{
  const fallback=groups[card.dataset.artPage]||{colours:[],settings:[]};
  const tags=card.dataset.artTags.toLowerCase().split('|');
  const read=(prefix,defaults)=>{const explicit=tags.filter(t=>t.startsWith(prefix+':')).map(t=>t.slice(prefix.length+1).trim());return explicit.length?explicit:defaults;};
  return {card,price:Number(card.dataset.artPrice)/100,sold:tags.includes('sold'),colours:read('colour',fallback.colours),settings:read('setting',fallback.settings)};
 });
 function update(){
  const price=form.elements.price.value,colour=form.elements.colour.value,setting=form.elements.setting.value;
  let visible=0;
  entries.forEach(entry=>{
   const priceMatch=!price||(!entry.sold&&((price==='small'&&entry.price<=75)||(price==='larger'&&entry.price>75)));
   const match=priceMatch&&(!colour||entry.colours.includes(colour))&&(!setting||entry.settings.includes(setting));
   entry.card.hidden=!match;
   if(match)visible++;
  });
  count.textContent=count.dataset.template.replace('__COUNT__',String(visible));
  empty.hidden=visible!==0;
 }
 form.addEventListener('submit',event=>event.preventDefault());
 form.addEventListener('change',update);
 form.addEventListener('reset',()=>setTimeout(update,0));
 form.dataset.ready='true';form.hidden=false;update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseJJFilters);else initialiseJJFilters();
document.addEventListener('shopify:section:load',initialiseJJFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jj-rotating-hero"] && !Shopify.designMode) return;
  try {
    function initialiseJJHero(){
 document.querySelectorAll('[data-rotating-hero]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const options=JSON.parse(root.querySelector('.jj-hero-options').textContent);
  if(!options.length)return;
  let previous='';
  try{previous=localStorage.getItem('jj-last-hero')||'';}catch{}
  const alternatives=options.filter(art=>String(art.id)!==previous);
  const pool=alternatives.length?alternatives:options;
  const chosen=pool[Math.floor(Math.random()*pool.length)];
  const preloaded=new Image();
  preloaded.onload=()=>{
   if(!root.isConnected)return;
   const figure=root.querySelector('figure');
   const image=root.querySelector('img');
   const imageLink=root.querySelector('.jj-hero-image-link');
   const captionLink=root.querySelector('figcaption a');
   image.removeAttribute('srcset');image.removeAttribute('sizes');
   image.src=chosen.image;image.alt=chosen.title;
   image.width=chosen.width;image.height=chosen.height;
   figure.style.setProperty('--hero-ratio',chosen.width/chosen.height);
   imageLink.href=chosen.url;imageLink.setAttribute('aria-label',chosen.label);
   captionLink.href=chosen.url;captionLink.textContent=chosen.caption||chosen.title;
   try{localStorage.setItem('jj-last-hero',String(chosen.id));}catch{}
  };
  preloaded.src=chosen.image;
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseJJHero);else initialiseJJHero();
document.addEventListener('shopify:section:load',initialiseJJHero);
  } catch(e) { console.error(e); }
})();

})();
